import { useEffect, useState } from 'react'

export const NOTIFICATIONS_DESKTOP_QUERY = '(min-width: 768px)'

function mediaQueryMatches(): boolean {
  if (typeof window === 'undefined' || !window.matchMedia) return false
  return window.matchMedia(NOTIFICATIONS_DESKTOP_QUERY).matches
}

/**
 * D-053: notifications expose pull-to-refresh below 768 px and a visible
 * refresh control at 768 px and above. The listener swaps affordances on
 * resize/responsive testing without reloading the screen.
 */
export function useNotificationsIsDesktop(): boolean {
  const [desktop, setDesktop] = useState(mediaQueryMatches)

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return
    const query = window.matchMedia(NOTIFICATIONS_DESKTOP_QUERY)
    const update = () => setDesktop(query.matches)
    update()
    query.addEventListener?.('change', update)
    return () => query.removeEventListener?.('change', update)
  }, [])

  return desktop
}
